import { useState } from 'react';
import { Outlet } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { LeftNav } from './LeftNav'

export function AppShell() {
	return (
		<div className="flex flex-col items-center h-screen w-screen custom-gradient">
			<div className="flex flex-col overflow-hidden w-full h-full">
				<Header />
				<div className='flex flex-row overflow-hidden w-full h-full'>
					<Outlet />
				</div>
			</div>
		</div>
	);
}